import React, { useState, useEffect } from 'react'
import { Box, Typography, FormControl, Select, MenuItem, Grid, Divider } from '@mui/material'
import { TextInput, FileUploaderInput } from '../../../../ui'
import { useIntl } from 'react-intl'

export const PrescriptorsPanel = ({ instaladores }) => {
    const { formatMessage } = useIntl()
    const [selectedIdx, setSelectedIdx] = useState(0)
    useEffect(() => {
        setSelectedIdx(0)
    }, [instaladores])

    if (!instaladores || instaladores.length === 0) return null

    const instalador = instaladores[selectedIdx]

    const fields = [
        { name: 'razon_social', value: instalador.nombre || instalador.razon_social, title: 'Nombre / Razón Social' },
        { name: 'nif', value: instalador.cif || instalador.nif, title: 'NIF' },
        { name: 'email', value: instalador.email, title: 'Email' },
        { name: 'telefono', value: instalador.telefono, title: 'Teléfono' },
    ]

    return (
        <Box sx={{ marginTop: '30px', marginBottom: '20px' }}>
            <Divider sx={{ marginBottom: 3 }} />
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <Typography variant="h6" color="primary">
                    {formatMessage({
                        id: 'pages.eeii.detail.prescriptors.panel.title',
                        defaultMessage: 'Instaladores de la empresa prescriptora'
                    })}                </Typography>
                {instaladores.length > 1 && (
                    <FormControl size="small" variant="outlined" sx={{ minWidth: 250 }}>
                        <Select value={selectedIdx} onChange={(e) => setSelectedIdx(e.target.value)}>
                            {instaladores.map((inst, i) => (
                                <MenuItem key={inst.id || i} value={i}>
                                    {inst.nombre || inst.razon_social}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            </Box>
            <Grid container spacing={4} style={{ marginTop: 0, marginBottom: 0 }}>
                {fields.map((field) => (
                    <Grid key={field.name} size={{ xs: 12, sm: 6, md: 3 }}>
                        <Box display="block">
                            <TextInput
                                readOnly
                                required={false}
                                title={field.title}
                                value={field.value || '--'}
                                name={field.name}
                                onChange={() => { }}
                            />
                        </Box>
                    </Grid>
                ))}
            </Grid>

            {instalador.registro_industrial && instalador.registro_industrial.nombre && (
                <Box mt={3} pt={2} borderTop="1px solid rgba(0, 0, 0, 0.12)">
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box flex={1}>
                            <FileUploaderInput
                                readOnly
                                currentDoc={instalador.registro_industrial}
                                fileProps={{
                                    maxSize: 10000000,
                                    accept: ['application/pdf'],
                                }}
                                title={formatMessage({
                                    id: 'pages.eeii.detail.prescriptors.fields.registro_industrial.title',
                                    defaultMessage: 'Registro industrial'
                                })}
                            />
                        </Box>
                    </Box>
                </Box>
            )}
        </Box>
    )
}